<template>
         <div class="infobar">
                <ul class="list-inline mb-0">
                  <li class="list-inline-item">
                    <div class="profilebar">
                      <div class="dropdown">
                        <a
                          class="dropdown-toggle"
                          href="#"
                          role="button"
                          id="profilelink"
                          data-toggle="dropdown"
                          aria-haspopup="true"
                          aria-expanded="false"
                        >
                          <img
                            src="assets/images/users/profile.svg"
                            class="img-fluid"
                            alt="profile"
                          />
                          <span class="feather icon-chevron-down live-icon"></span>
                        </a>
                        <div
                          class="dropdown-menu dropdown-menu-right"
                          aria-labelledby="profilelink"
                        >
                          <div class="dropdown-item">
                            <div class="profilename">
                              <h5>{{cuser.firstname}} {{cuser.lastname}}</h5>
                            </div>
                          </div>
                          <div class="userbox">
                            <ul class="list-unstyled mb-0">
                              <li class="media dropdown-item d-none">
                                <a href="#" class="profile-icon">
                                  <img
                                    src="assets/images/svg-icon/user.svg"
                                    class="img-fluid"
                                    alt="user"
                                  />Il mio profilo
                                </a>
                              </li>
                             
                              <li class="media dropdown-item">
                                <a href="#" v-on:click="logout" class="profile-icon">
                                  <img
                                    src="assets/images/svg-icon/logout.svg"
                                    class="img-fluid"
                                    alt="logout"
                                  />Logout
                                </a>
                              </li>
                            </ul>
                          </div>
                        </div>
                      </div>
                    </div>
                  </li>
                </ul>
              </div>

</template>

<script>
export default {
   name: 'AppInfoBar',
   methods:{
logout(){

    this.$store.commit('clearAuth');
    this.$router.push({ name: 'route-login' });
}
  },
  computed: {
    authenticated() {
      return this.$store.getters.isAuthenticated;
    },
    operarators() {
      return this.$store.state.operarators;
    },
     cuser() {
      return this.$store.state.user;
    },
  },
 
};
</script>

<style>
</style>
